import eventsDetails from './../../utility/event-details'
import EventCard from './EventCard';

const EventsList = () => {
    const today = new Date();

    function isOngoing(evt) {
        return evt.date < today && today < evt.endDate;
    }
    function isUpcoming(evt) {
        return evt.date > today;
    }
    function isCompleted(evt) {
        return evt.date < today
    }

    function sortByDate(evt1, evt2) {
        return evt2.date - evt1.date
    }

    const upcomingEvents = eventsDetails.filter(isUpcoming)
    const ongoingEvents = eventsDetails.filter(isOngoing)
    const completedEvents = eventsDetails.filter(isCompleted)

    return (
        <>
            {
                ongoingEvents?.length
                    ?
                        <>
                            <p className='event-type'>Ongoing Events</p>
                            <div className='events-list-wrapper'>
                                {ongoingEvents.sort(sortByDate).map((evt, idx) =>
                                    <EventCard key={idx} event={evt} />
                                )}
                            </div>
                        </>
                    :   <></>
            }
            {
                upcomingEvents?.length
                    ?
                        <>
                            <p className='event-type'>Upcoming Events</p>
                            <div className='events-list-wrapper'>
                                {upcomingEvents.sort(sortByDate).map((evt, idx) =>
                                    <EventCard key={idx} event={evt} />
                                )}
                            </div>
                        </>
                    :   <></>
            }
            {
                completedEvents?.length
                    ?
                        <>
                            <p className='event-type'>Past Events</p>
                            <div className='events-list-wrapper'>
                                {completedEvents.sort(sortByDate).map((evt, idx) =>
                                    <EventCard key={idx} event={evt} />
                                )}
                            </div>
                        </>
                    :   <></>
            }
        </>
    )
}

export default EventsList